/**
 * The attributes every search box carries: a search box takes words to match,
 * not a sentence to correct.
 *
 * iOS turned « peurs » into « Peru's » and a capitalised « Krysta » went into
 * the recent searches as typed (mobile QA, 12 Oct 2026 — the app's Mat Bot and
 * Library fields dropped autocorrect, spell-check and auto-capitalisation the
 * same day). Safari on an iPhone applies the same three to a web `<input>`
 * unless told otherwise, so the web's search fields say so too.
 *
 * `autoCorrect` is Safari's own attribute; the other two are standard.
 */
export const SEARCH_INPUT_PROPS = {
  autoCapitalize: 'none',
  autoCorrect: 'off',
  spellCheck: false,
} as const
